<template>
    <div class="graph-button-switch">
        <button class="graph-switch uk-text-middle" @click="switchGraph">
            {{ text }}
            <img :src="require('@/assets/images/icons/icon-arrow-next.svg')" />
        </button>
    </div>
</template>

<script lang="js">
import Vue from "vue";

export default Vue.extend({
    name: "GraphSwitch",
    props: {
        text: {
            required: true,
            type: String,
        },
    },
    methods: {
        switchGraph(event) {
            event.preventDefault();
            this.$emit("switchGraph", true);
        },
    },
});
</script>
